import { useAppDispatch } from "store/hooks";
import {
  AudioReactionsTypes,
  audioReactions,
} from "modules/audioReactions/constants";
import { setAudioReactionDialog } from "modules/audioReactions/redux/slice";
import { useAudioReactions } from "modules/audioReactions/hooks";
import { Events, TRACKING_CONTEXT } from "modules/tracking";
import { useContext } from "react";
import { useSelector } from "react-redux";
import { selectCurrentEvent } from "modules/event/selectors";
import { useStyles } from "./styles";

interface Props {
  type: AudioReactionsTypes;
}

export const AudioReaction = ({ type }: Props): JSX.Element => {
  const { addAudioReaction } = useAudioReactions();
  const classes = useStyles();
  const dispatch = useAppDispatch();
  const { track } = useContext(TRACKING_CONTEXT);
  const currentEvent = useSelector(selectCurrentEvent);

  const handleClick = () => {
    dispatch(setAudioReactionDialog(false));
    addAudioReaction(type);
    track(Events.AUDIO_REACTION_SELECTED, {
      eventId: currentEvent?.id,
      eventType: currentEvent?.eventType,
      audioReaction: type,
    });
  };

  return (
    <div className={classes.container} data-testid="audio-reaction">
      <button
        type="button"
        name="emoji-button"
        className={classes.emojiButton}
        onClick={handleClick}
        data-testid={`audio-reaction-${type}`}
      >
        <img
          className={classes.emojiImage}
          src={audioReactions[type]}
          alt={`${type} reaction`}
        />
      </button>
    </div>
  );
};
